module.exports = __webpack_public_path__ + "static/logo--carecar-e3a31720799eaaa8066acd0d5ac8aa0c.svg";